export default __webpack_public_path__ + "static/media/icoSnapchat.b00452e7.svg";